import { useLocalStorage } from "@mantine/hooks";

import type { MarketCar } from "@/types/market";

const namespace = "recentlyViewedCars";

export const useRecentCars = () => {
  const [recentlyViewedCars, setRecentlyViewedCars] = useLocalStorage<MarketCar[]>({
    key: namespace,
    defaultValue: [],
  });

  function addCar(data: MarketCar) {
    setRecentlyViewedCars((prevCars) => {
      const filteredCars = prevCars.filter((car) => car.id !== data.id);
      return [data, ...filteredCars].slice(0, 6);
    });
  }

  return { recentlyViewedCars, addRecentlyViewedCars: addCar };
};
